import React, { useState } from 'react';

function AddGLCodeModal({ isOpen, onClose, onSubmit, users }) {
  const [formData, setFormData] = useState({
    gl_code: '',
    description: '',
    area: '',
    mid: '',
    second: '',
    approval: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    // Reset form
    setFormData({
      gl_code: '',
      description: '',
      area: '',
      mid: '',
      second: '',
      approval: ''
    });
  };

  const handleCancel = () => {
    // Reset form
    setFormData({
      gl_code: '',
      description: '',
      area: '',
      mid: '',
      second: '',
      approval: ''
    });
    onClose();
  };

  if (!isOpen) return null;

  // Convert users object to array for dropdowns
  const userOptions = Object.entries(users).map(([id, name]) => ({
    id,
    name
  }));

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-[600px] shadow-lg rounded-md bg-white">
        <div className="mt-3">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-lg font-medium text-gray-900">Add GL Code</h4>
            <button
              onClick={handleCancel}
              className="text-gray-400 hover:text-gray-600"
            >
              <span className="sr-only">Close</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Left Column */}
              <div className="space-y-4">
                {/* GL Code */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    GL Code
                  </label>
                  <input
                    type="text"
                    name="gl_code"
                    value={formData.gl_code}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>

                {/* GL Description */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    GL Description
                  </label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>

                {/* Area */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Area
                  </label>
                  <input
                    type="text"
                    name="area"
                    value={formData.area}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-4">
                {/* First Approver */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    First Approver
                  </label>
                  <select
                    name="mid"
                    value={formData.mid}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Select First Approver</option>
                    {userOptions.map(user => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Second Approver */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Second Approver
                  </label>
                  <select
                    name="second"
                    value={formData.second}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Select Second Approver</option>
                    {userOptions.map(user => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* SAP Approver */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    SAP Approver
                  </label>
                  <select
                    name="approval"
                    value={formData.approval}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    required
                  >
                    <option value="">Select SAP Approver</option>
                    {userOptions.map(user => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3 pt-6">
              <button
                type="button"
                onClick={handleCancel}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                Add GL Code
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddGLCodeModal;
